// extracted by mini-css-extract-plugin
export default {"mediaQueries":"\"../styles/mediaQueries.css\"","mqMedium":"only screen and (min-width: 768px)","reservations":"Reservations_reservations__4dPKs"};